import {DeliveryIntervals as DeliveryIntervalsBase} from '@yandex-delivery/form'
import React from 'react'

import {i18n} from 'src/shared/config'

import {useDeliveryIntervals} from './hooks'

type Props = {
  name: string
  isLoading?: boolean
}

export function DeliveryIntervals(props: Props): React.ReactElement<Props> {
  const {name, isLoading = false} = props
  const {deliveryDate, dateList, intervalList} = useDeliveryIntervals(name)

  return (
    <DeliveryIntervalsBase
      dates={dateList}
      intervals={intervalList}
      isLoading={isLoading}
      name={name}
      placeholders={{
        date: i18n('cargo.create.due.select-date', 'Выберите дату'),
        interval: i18n('ndd.delivery-policy.input.time.placeholder', 'Выберите интервал'),
      }}
      selectedDate={deliveryDate}
    />
  )
}
